import { bl_rvm_cfp_engagement_line_RowClass } from '../../../dbschema/bl_rvm_cfp_engagement_line.model';
import { BaseContainerModel } from '../../base-container.model';

export class CfpEngagementLineContainerModel extends BaseContainerModel {
  bl_rvm_cfp_engagement_line: bl_rvm_cfp_engagement_line_RowClass = new bl_rvm_cfp_engagement_line_RowClass();
}
